/* eslint-disable no-return-await */
import axios, { AxiosResponse } from 'axios';
import { IngoApiPath } from 'enums/IngoApiPath';
import { ILeaderBoard } from 'interfaces/LeaderBoard';

export const getIngoLeaderBoards = async (countryCode: string): Promise<AxiosResponse<ILeaderBoard[]>> => {
  return await axios.get<ILeaderBoard[]>(`${process.env.REACT_APP_INGO_SERVICE_API}/${IngoApiPath.LeaderBoard}?country=${countryCode}`);
};
